import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getInitialActiveTab } from '../../helper';

interface ToggleState {
    activeTab: 'openBook' | 'assets';
}

const initialState: ToggleState = {
    activeTab: getInitialActiveTab(), // Default tab
};

const toggleSlice = createSlice({
    name: 'toggle',
    initialState,
    reducers: {
        setActiveTab: (state, action: PayloadAction<'openBook' | 'assets'>) => {
            state.activeTab = action.payload;
        },
    },
});

export const { setActiveTab } = toggleSlice.actions;
export default toggleSlice.reducer;
